import PropTypes from 'prop-types'
import classes from './style.module.css'
import theme from '../../utils/theme'

export const Text = ({
	children,
	inline,
	color = 'black',
	fontSize = '',
	fontWeight = '',
	textAlign = '',
	textTransform = '',
	whiteSpace = '',
}) => {

	const style = {
		fontSize,
		fontWeight,
		textAlign,
		textTransform,
		whiteSpace,
		color: theme[color] ?? color,
	}

	return inline ? (
		<span style={style}>
			{children}
		</span>
	) : (
		<p className={classes.text} style={style}>
			{children}
		</p>
	)
}

Text.propTypes = {
	children: PropTypes.any,
	inline: PropTypes.any,
	display: PropTypes.string,
	color: PropTypes.string,
	fontSize:  PropTypes.string,
	fontWeight: PropTypes.string,
	textAlign: PropTypes.string,
	textTransform: PropTypes.string,
	whiteSpace: PropTypes.string,
}